import * as React from "react";
import { BrManageContentButton } from "@bloomreach/react-sdk";
import { getDisplayName } from "@grandvisionhq/utils";
function withEditableContent(Component) {
  const displayName = getDisplayName(Component);
  const WithEditableContent = (props) => {
    if (!props.content || !props.content.document) {
      return /* @__PURE__ */ React.createElement(Component, { ...props });
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(BrManageContentButton, { content: props.content.document })), /* @__PURE__ */ React.createElement(Component, { ...props }));
  };
  WithEditableContent.displayName = `WithEditableContent(${displayName})`;
  return WithEditableContent;
}
export {
  withEditableContent
};
//# sourceMappingURL=with-editable-content.js.map
